export default "{\n    \"addImages\": \"Agregar imágenes\",\n    \"deleteImage\": \"Eliminar imagen\"\n}\n"